export default "__VITE_ASSET__CUTEzNHE__"